import React from 'react'
import { Modal, ModalHeader, Button } from 'reactstrap';
import { FormCedula } from '../../../components/users/FormCedula';
import { Dialog } from 'primereact/dialog';

export const ModalCedula = (props) => {
    const {
        modalCedula, toggleCedula, modalTitleCard, typeCedula, handleInputChange, professional_license, userId, saveProfessionalLicense, handleInputChangeC, formValuesC
    } = props;



    return (
        <Dialog
            visible={modalCedula}
            onHide={toggleCedula}
            maskClassName="custom-total-mask"
            header={
                <div className="Global-dialog-header">
                    <div className="Global-dialog-header__content">
                        <div className="Global-dialog-icon">
                            <i className="icofont icofont-ui-v-card"></i>
                        </div>

                        <div>
                            <div className="Global-dialog-title">
                                {modalTitleCard}
                            </div>
                        </div>
                    </div>
                </div>
            }
            draggable={false}
            className={`Global-dialog Global-dialog Global-blue Global-small-v3`}
            closable={false}
            footer={
                <>
                    <Button

                        size="sm"
                        color="secondary"
                        onClick={saveProfessionalLicense}
                    >
                        {"Guardar"}
                    </Button>
                    <Button size="sm" color='danger' type="button" onClick={toggleCedula}>Cancelar</Button>

                </>
            }

        >

            {
                typeCedula === "typeCedula"
                    ?
                    <FormCedula button='Guardar' {...{
                        toggleCedula, modalCedula, professional_license, userId, saveProfessionalLicense, handleInputChangeC, typeCedula, formValuesC
                    }} />
                    : ""
            }

        </Dialog>
    );
};

